import { Components, Theme } from '@mui/material/styles';

import * as Borders from 'src/theme/borders';
import * as Shadows from 'src/theme/shadows';

const MuiMenu: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    paper: {
      border: Borders.GrayThinBorder,
      boxShadow: Shadows.DropdownMenuShadow,
    },
    list: {
      padding: '4px 0',
    },
  },
};

export default MuiMenu;
